module.exports = __webpack_public_path__ + "static/media/prev-button.6d698fba.svg";